const apiName = {
  GetCustomerIndexInfo: {
    // 获取个人中心信息
    module: 'b2b',
    address: 'Customer/GetCustomerIndexInfo',
  },
  GetOrderListInfo: {
    // 获取订单中心订单列表
    module: 'b2b',
    address: 'Order/GetOrderListInfo',
  },
  GetHotelOrderInfo: {
    // 获取酒店订单详情
    module: 'b2b',
    address: 'Order/GetHotelOrderInfo',
  },
  GetServerPhone: {
    // 获取客服电话
    module: 'b2b',
    address: 'Order/GetServerPhone',
  },
  GetSystemTime: {
    // 获取系统时间
    module: 'b2b',
    address: 'Common/GetSystemTime',
  },
  SearchHotelDestinationList: {
    // 获取散房酒店目的
    module: 'b2b',
    address: 'Hotel/SearchHotelDestinationList',
  },
  GetHotelOrderPriceV2: {
    // 获取酒店详情费用明细
    module: 'b2b',
    address: 'Order/GetHotelOrderPriceV2',
  },
  GetTrainOrderDetailV2: {
    // 获取火车票订单详信息
    module: 'b2b',
    address: 'TrainTicket/GetTrainOrderDetailV2',
  },
  GetTrainOrderStatus: {
    // 获取火车票订单状态
    module: 'b2b',
    address: 'TrainTicket/GetTrainOrderStatus',
  },
  GetTrainRefundInfo: {
    // 获取火车票退改规
    module: 'b2b',
    address: 'TrainTicket/GetTrainRefundInfo',
  },
  ApplyTrainOrderRefund: {
    // 提交火车票退票申请
    module: 'b2b',
    address: 'TrainTicket/ApplyTrainOrderRefund',
  },
  CancelTrainOrder: {
    // 取消火车票订单
    module: 'b2b',
    address: 'TrainTicket/CancelTrainOrder',
  },
  CancelGrabOrder: {
    // 取消火车票抢票
    module: 'b2b',
    address: 'TrainTicket/CancelGrabOrder',
  },
  UpgradeGrabOrder: {
    // 升级火车票加速包
    module: 'b2b',
    address: 'TrainTicket/UpgradeGrabOrder',
  },
  ProcessBookSeatConfirm: {
    // 取消/确认火车票出票
    module: 'b2b',
    address: 'TrainTicket/ProcessBookSeatConfirm',
  },
  GetCommonConfig: {
    //获取火车票日期控件信息
    module: 'b2b',
    address: 'Common/GetCommonConfig',
  },
  ScatteredGetHotelFilter: {
    // 获取散房酒店筛选信息
    module: 'b2b',
    address: 'Hotel/GetHotelFilter',
  },
  SearchPrompts: {
    // 获取散房酒店搜索提示
    module: 'b2b',
    address: 'Hotel/SearchPrompts',
  },
  GetTrainStationList: {
    // 获取火车票出发地目的地
    module: 'b2b',
    address: 'TrainTicket/GetTrainStationList',
  },
  TrainGetChangePassengerInfo: {
    // 获取火车票改签乘客信息
    module: 'b2b',
    address: 'TrainTicket/GetChangePassengerInfo',
  },
  HotelSearch: {
    // 散房酒店列表搜索
    module: 'b2b',
    address: 'Hotel/Search',
  },
  GetTrainList: {
    // 获取直达车次列表
    module: 'b2b',
    address: 'TrainTicket/GetTrainList',
  },
  SearchTransferTrains: {
    // 获取中转列表
    module: 'b2b',
    address: 'TrainTicket/SearchTransferTrains',
  },
  GetTrainDetail: {
    // 获取直达火车票1.5详情
    module: 'b2b',
    address: 'TrainTicket/GetTrainDetail',
  },
  SearchTransferTrainTicket: {
    // 获取中转火车票1.5详情
    module: 'b2b',
    address: 'TrainTicket/SearchTransferTrainTicket',
  },
  CheckTrainStandard: {
    // 验证火车票差标
    module: 'b2b',
    address: 'TrainTicket/CheckTrainStandard',
  },
  GetTrainOrderChange: {
    // 获取火车票改签订单提交信息
    module: 'b2b',
    address: 'TrainTicket/GetTrainOrderChange',
  },
  ChangeTrainOrder: {
    // 火车票订单改签提交
    module: 'b2b',
    address: 'TrainTicket/ChangeTrainOrder',
  },
  GetOverStandardReson: {
    // 获取超标原因
    module: 'b2b',
    address: 'Order/GetOverStandardReson',
  },
  GetOrderPayInfo: {
    // 获取支付信息
    module: 'b2b',
    address: 'Order/GetOrderPayInfo',
  },
  GetPayInfoByPayType: {
    // 选择支付类型返回
    module: 'b2b',
    address: 'Common/GetPayInfoByPayType',
  },
  GetTrainOrderSubmit: {
    // 获取火车票订单提交信息
    module: 'b2b',
    address: 'TrainTicket/GetTrainOrderSubmit',
  },
  GetOrderInfoAfterPayment: {
    // 获取支付成功信息
    module: 'b2b',
    address: 'Common/GetOrderInfoAfterPayment',
  },
  GetIdentityTypeList: {
    // 获取证件类型列表
    module: 'b2b',
    address: 'Common/GetIdentityTypeList',
  },
  GetNationalityDataList: {
    // 获取国籍列表
    module: 'b2b',
    address: 'Common/GetNationalityDataList',
  },
  CreateTrainOrder: {
    // 创建火车票订单
    module: 'b2b',
    address: 'TrainTicket/CreateTrainOrder',
  },
  QueryMyTravelStandard: {
    // 查询我的差旅标准
    module: 'b2b',
    address: 'Customer/QueryMyTravelStandard',
  },
  AddHotelPassenger: {
    // 增加酒店常旅
    module: 'b2b',
    address: 'Customer/AddHotelPassenger',
  },
  DDGetLoginUrl: {
    // 获取钉钉登录地址
    module: 'b2b',
    address: 'Customer/GetLoginUrl',
  },
  Login: {
    //登录
    module: 'b2b',
    address: 'Customer/LoginV2',
  },
  GetBusinessOrders: {
    // 获取订单详情出差单信息
    module: 'b2b',
    address: 'Order/GetBusinessOrders',
  },
  GetFlightListV2: {
    // 获取航班列表数据
    module: 'b2b',
    address: 'Flight/GetFlightListV2',
  },
  GetAirportCityList: {
    // 获取机场城市列表
    module: 'b2b',
    address: 'Flight/GetAirportCityList',
  },
  FlightKeyWordSearch: {
    // 机场目的地搜索
    module: 'b2b',
    address: 'Flight/FlightKeyWordSearch',
  },
  GetFlightOrderDetailV2: {
    // 获取机票订单详情
    module: 'b2b',
    address: 'Flight/GetFlightOrderDetailV2',
  },
  GetBaggageruleAndRefundModifyStipulate: {
    // 获取机票退改规则和行李额
    module: 'b2b',
    address: 'Flight/GetBaggageruleAndRefundModifyStipulate',
  },
  CancelFlightOrder: {
    // 取消机票订单
    module: 'b2b',
    address: 'Flight/CancelFlightOrder',
  },
  GetPassengersAndReasons: {
    // 获取乘客列表和退改原因接口
    module: 'b2b',
    address: 'Flight/GetOrderInfosForChangeAndRefund',
  },
  GetSegmentsInfos: {
    // 获取航班信息
    module: 'b2b',
    address: 'Flight/GetSegmentsInfos',
  },
  GetFlightSeatList: {
    // 获取航班仓位列表
    module: 'b2b',
    address: 'Flight/GetFlightSeatList',
  },
  FlightPassengersModify: {
    // 提交修改乘客
    module: 'b2b',
    address: 'Flight/FlightPassengersModify',
  },
  GetFlightOrderSubmitInfo: {
    // 获取国内单程机票提交订单信息
    module: 'b2b',
    address: 'Flight/GetFlightOrderSubmitInfo',
  },
  GetFlightOrderSubmitForCommonlyUsed: {
    // 通过常用获取国内单程机票提交订单信息
    module: 'b2b',
    address: 'Flight/GetFlightOrderSubmitForCommonlyUsed',
  },
  GetChangeFlightList: {
    // 获取改签航班列表
    module: 'b2b',
    address: 'Flight/GetChangeFlightList',
  },
  GetChangeFlightDetail: {
    // 获取改签航班详情
    module: 'b2b',
    address: 'Flight/GetChangeFlightDetail',
  },
  GetRefundAndModifyStipulate: {
    // 获取退改签规则
    module: 'b2b',
    address: 'Flight/GetRefundAndModifyStipulate',
  },
  ValidateFlightOrder: {
    // 校验下单的舱位及价格
    module: 'b2b',
    address: 'Flight/ValidateFlightOrder',
  },
  CheckFlightStandard: {
    // 验证机票差标
    module: 'b2b',
    address: 'Flight/CheckFlightStandard',
  },
  CreateFlightOrder: {
    // 国内单程机票提交订单
    module: 'b2b',
    address: 'Flight/CreateFlightOrder',
  },
  GetFlightOrderChange: {
    // 获取改签订单提交信息
    module: 'b2b',
    address: 'Flight/GetFlightOrderChange',
  },
  ChangeFlightOrder: {
    // 提交改签
    module: 'b2b',
    address: 'Flight/ChangeFlightOrder',
  },
  GetReturnFlightOrderSubmitInfo: {
    // 获取国内机票往返填单信息
    module: 'b2b',
    address: 'Flight/GetReturnFlightOrderSubmitInfo',
  },
  CreateReturnFlightOrder: {
    // 提交国内往返机票订单
    module: 'b2b',
    address: 'Flight/CreateReturnFlightOrder',
  },
  GetRefundTicketCostInfo: {
    // 获取退票费用接口
    module: 'b2b',
    address: 'Flight/GetRefundTicketCostInfo',
  },
  ApplyFlightOrderRefund: {
    // 提交机票退票信息
    module: 'b2b',
    address: 'Flight/ApplyFlightOrderRefund',
  },
  GetApproveOrderList: {
    //获取审批订单列表
    module: 'b2b',
    address: 'TMC/GetApproveOrderList',
  },
  GetApproverOrderNum: {
    //获取未审批订单数量
    module: 'b2b',
    address: 'Customer/GetApproverOrderNum',
  },
  TMCGetFlightOrderDetail: {
    //获取审批机票订单详情
    module: 'b2b',
    address: 'TMC/GetFlightOrderDetail',
  },
  TMCApprovalTravelBusinessOrder: {
    // 审批订单
    module: 'b2b',
    address: 'TMC/ApprovalTravelBusinessOrder',
  },
  TMCGetHotelOrderDetail: {
    // 获取TMC酒店订单详情
    module: 'b2b',
    address: 'TMC/GetHotelOrderInfo',
  },
  TMCGetTrainOrderDetail: {
    // 获取TMC火车票订单详情
    module: 'b2b',
    address: 'TMC/GetTrainOrderDetail',
  },
  UploadImage: {
    // 上传图片
    module: 'b2b',
    address: 'Common/UploadImage',
  },
  ValidateFlightSeat: {
    // 验舱验价
    module: 'b2b',
    address: 'InternationalFlightResource/ValidateFlightSeat',
  },
  GetTrainStationListV2: {
    // 火车站搜索出发地目的地
    module: 'b2b',
    address: 'TrainTicket/GetTrainStationListV2',
  },
  GetFlightOrderSubmit: {
    // 国际机票获取航班信息
    module: 'b2b',
    address: 'InternationalFlightResource/GetFlightOrderSubmit',
  },
  CreateInternationalFlightOrder: {
    // 国际机票订单提交
    module: 'b2b',
    address: 'InternationalFlightResource/CreateFlightOrder',
  },
  SendVerificationCode: {
    // 发送短信验证码
    module: 'b2b',
    address: 'Common/SendVerificationCode',
  },
  SendTravelVerificationCode: {
    // 发送短信验证码-滑块
    module: 'b2b',
    address: 'Common/SendTravelVerificationCode',
  },
  RegisterCustomerInfo: {
    // 个人注册
    module: 'b2b',
    address: 'Customer/RegisterCustomerInfo',
  },
  ForgetPasswordCheck: {
    // 修改密码验证短信验证码
    module: 'b2b',
    address: 'Customer/ForgetPasswordCheck',
  },
  ForgetPasswordSetPassword: {
    // 重置密码
    module: 'b2b',
    address: 'Customer/ForgetPasswordSetPassword',
  },
  CheckPhoneIsRegister: {
    // 验证手机号码是否已注册
    module: 'b2b',
    address: 'Customer/CheckPhoneIsRegister',
  },
  VerificationCodeCheck: {
    // 验证注册验证码
    module: 'b2b',
    address: 'Customer/VerificationCodeCheck',
  },
  HouseKeeperRegister: {
    //提交注册
    module: 'b2b',
    address: 'Customer/HouseKeeperRegister',
  },
  GetCommonCurrentLocation: {
    //定位
    module: 'b2b',
    address: 'Common/GetCurrentLocation',
  },
  GetDestinationList: {
    //定位
    module: 'b2b',
    address: 'Search/GetDestinationList',
  },
  SearchDestinationList: {
    //搜索
    module: 'b2b',
    address: 'Search/SearchDestinationList',
  },
  SchemeOrderSubmitForExternal: {
    //提交定制旅行
    module: 'b2b',
    address: 'Scheme/SchemeOrderSubmitForExternal',
  },
  CreateMICEOrder: {
    //提交会议
    module: 'b2b',
    address: 'Scheme/CreateMICEOrder',
  },
  CreateCustomizedOrder: {
    //提交团队机票
    module: 'b2b',
    address: 'Scheme/CreateCustomizedOrder',
  },
  GetInvoiceOrderList: {
    //查询可开发票列表
    module: 'b2b',
    address: 'Customer/GetInvoiceOrderList',
  },
  GetCollectionHotelList: {
    //收藏酒店列表
    module: 'b2b',
    address: 'Customer/GetCollectionHotelList',
  },
  GetHistoryInvoiceList: {
    //开票历史
    module: 'b2b',
    address: 'Customer/GetHistoryInvoiceList',
  },
  GetCustomerInfo: {
    //获取我的详细信息
    module: 'b2b',
    address: 'Customer/GetCustomerInfo',
  },
  GetCustomerInvoiceDetail: {
    //开票详情
    module: 'b2b',
    address: 'Customer/GetCustomerInvoiceDetail',
  },
  EditPassword: {
    //修改密码
    module: 'b2b',
    address: 'Customer/EditPassword',
  },
  GetInvoiceDetialOrders: {
    //所含订单
    module: 'b2b',
    address: 'Customer/GetInvoiceDetialOrders',
  },
  GetInvoiceSubmitInfo: {
    //发票详情
    module: 'b2b',
    address: 'Customer/GetInvoiceSubmitInfo',
  },
  GetInvoiceTitleList: {
    //发票抬头列表
    module: 'b2b',
    address: 'Customer/GetInvoiceTitleList',
  },
  GetMailList: {
    //配送地址
    module: 'b2b',
    address: 'Customer/GetMailList',
  },
  AddCustomerInvoice: {
    //发票提交
    module: 'b2b',
    address: 'Customer/AddCustomerInvoice',
  },
  SubmitInvoiceTitleInfo: {
    //发票抬头提交
    module: 'b2b',
    address: 'Customer/SubmitInvoiceTitleInfo',
  },
  GetInvoiceTitleInfo: {
    //发票抬头提交
    module: 'b2b',
    address: 'Customer/GetInvoiceTitleInfo',
  },
  DelInvoiceTitleInfo: {
    //发票抬头删除
    module: 'b2b',
    address: 'Customer/DelInvoiceTitleInfo',
  },
  GetQuestionType: {
    //获取问题类型
    module: 'b2b',
    address: 'Scheme/GetQuestionType',
  },
  GetQuestios: {
    //获取常用问题
    module: 'b2b',
    address: 'Scheme/GetQuestios',
  },
  GetProvinceList: {
    //获取省
    module: 'b2b',
    address: 'Common/GetProvinceList',
  },
  GetCityList: {
    //获取市
    module: 'b2b',
    address: 'Common/GetCityList',
  },
  GetDisAreaList: {
    //获取区
    module: 'b2b',
    address: 'Common/GetDisAreaList',
  },
  SubmitMailInfo: {
    //配送地址提交
    module: 'b2b',
    address: 'Customer/SubmitMailInfo',
  },
  DelMailInfo: {
    //地址删除
    module: 'b2b',
    address: 'Customer/DelMailInfo',
  },
  GetMailInfo: {
    //获取配送地址
    module: 'b2b',
    address: 'Customer/GetMailInfo',
  },
  GetQuestionDetail: {
    //获取问题详情
    module: 'b2b',
    address: 'Scheme/GetQuestionDetail',
  },
  AddQuestionIsHelpNum: {
    //问题答案是否有帮助
    module: 'b2b',
    address: 'Scheme/AddQuestionIsHelpNum',
  },
  DeletePassenger: {
    //删除常旅
    module: 'b2b',
    address: 'Customer/DeletePassenger',
  },
  GetBannerList: {
    //获取首页Banner列表
    module: 'b2b',
    address: 'Common/GetBannerList',
  },
  GetPublicConfigValue: {
    //根据Key获取配置信息
    method: 'POST',
    module: 'b2b',
    address: 'Common/GetPublicConfigValue',
  },
  GetMyCostCenter: {
    //我的成本中心
    module: 'b2b',
    address: 'Customer/GetMyCostCenter',
  },
  GetVersionInfo: {
    //获取当前版本信息
    module: 'b2b',
    address: 'Common/GetVersionInfo',
  },
  SearchOrderListInfo: {
    //搜索订单
    module: 'b2b',
    address: 'Order/GetOrderListInfoV2',
  },
  GetRechargeTips: {
    //获取充值提示
    module: 'b2b',
    address: 'Customer/GetRechargeTips',
  },
  RechargeOffline: {
    //线下充值
    module: 'b2b',
    address: 'Customer/RechargeOffline',
  },
  AddCostInvoice: {
    //识别发票并添加
    module: 'b2b',
    address: 'CustomerBill/AddCostInvoice',
  },
  DeleteCostInvoice: {
    //删除发票
    module: 'b2b',
    address: 'CustomerBill/DeleteCostInvoice',
  },
  SaveCustomerCostType: {
    //保存费用类型
    module: 'b2b',
    address: 'CustomerBill/SaveCustomerCostType',
  },
  GetCostTypeList: {
    //获取费用类型列表
    module: 'b2b',
    address: 'CustomerBill/GetCostTypeList',
  },
  DeleteCustomerCostType: {
    //删除费用类型
    module: 'b2b',
    address: 'CustomerBill/DeleteCustomerCostType',
  },
  SaveCost: {
    //保存费用
    module: 'b2b',
    address: 'CustomerBill/SaveCost',
  },
  GetCustomerCostList: {
    //获取费用列表
    module: 'b2b',
    address: 'CustomerBill/GetCustomerCostList',
  },
  GetCustomerCostDetail: {
    //获取费用明细
    module: 'b2b',
    address: 'CustomerBill/GetCustomerCostDetail',
  },
  UpdateCustomerCostStuatus: {
    //修改费用明细
    module: 'b2b',
    address: 'CustomerBill/UpdateCustomerCostStuatus',
  },
  CreateTrevalApplyBill: {
    //创建出差申请单
    module: 'b2b',
    address: 'CustomerBill/CreateTrevalApplyBill',
  },
  CreateDailyApplyBill: {
    //创建日常申请单
    module: 'b2b',
    address: 'CustomerBill/CreateDailyApplyBill',
  },
  CreateLoanApplyBill: {
    //创建借款申请单
    module: 'b2b',
    address: 'CustomerBill/CreateLoanApplyBill',
  },
  CreateReimbursementBill: {
    //创建借款申请单
    module: 'b2b',
    address: 'CustomerBill/CreateReimbursementBill',
  },
  SaveCollectionInfo: {
    //保存收款信息
    module: 'b2b',
    address: 'CustomerBill/SaveCollectionInfo',
  },
  DeleteCollectionInfo: {
    //删除收款信息
    module: 'b2b',
    address: 'CustomerBill/DeleteCollectionInfo',
  },
  GetCollectionInfoList: {
    //获取收款信息列表
    module: 'b2b',
    address: 'CustomerBill/GetCollectionInfoList',
  },
  GetCollectionInfoDetail: {
    //获取收款信息详情
    module: 'b2b',
    address: 'CustomerBill/GetCollectionInfoDetail',
  },
  GetAllWriteOffLoanBill: {
    //获取所有未核销的借款单信息
    module: 'b2b',
    address: 'CustomerBill/GetAllWriteOffLoanBill',
  },
  GetDailyApplyBillDetail: {
    //获取日常申请单详情
    module: 'b2b',
    address: 'CustomerBill/GetDailyApplyBillDetail',
  },
  GetTravelApplyBillDetail: {
    //获取出差申请单详情
    module: 'b2b',
    address: 'CustomerBill/GetTravelApplyBillDetail',
  },
  GetLoanApplyBillDetail: {
    //获取借款单详情
    module: 'b2b',
    address: 'CustomerBill/GetLoanApplyBillDetail',
  },
  GetReimbursementBillDetail: {
    //获取报销单明细
    module: 'b2b',
    address: 'CustomerBill/GetReimbursementBillDetail',
  },
  GetBillList: {
    //获取单据列表
    module: 'b2b',
    address: 'CustomerBill/GetBillList',
  },
  GetApplyBillStatistics: {
    //获取日常单据统计信息
    module: 'b2b',
    address: 'CustomerBill/GetApplyBillStatistics',
  },
  GetLoanBillStatistics: {
    //获取借款单据统计信息
    module: 'b2b',
    address: 'CustomerBill/GetLoanBillStatistics',
  },
  GetReimbursementBillStatistics: {
    //获取报销单据统计信息
    module: 'b2b',
    address: 'CustomerBill/GetReimbursementBillStatistics',
  },
  GetMyAccountBook: {
    //获取账本统计信息
    module: 'b2b',
    address: 'CustomerBill/GetMyAccountBook',
  },
  ApprovalBill: {
    //审批单据
    module: 'b2b',
    address: 'CustomerBill/ApprovalBill',
  },
  BillMakeMoney: {
    //打款
    module: 'b2b',
    address: 'CustomerBill/BillMakeMoney',
  },
  DeleteCustomerCost: {
    //删除已移除费用
    module: 'b2b',
    address: 'CustomerBill/DeleteCustomerCost',
  },
  SearchStuffAndDepartment: {
    //根据名称搜索部门或人员
    module: 'b2b',
    address: 'Customer/SearchStuffAndDepartment',
  },
  GetCheckFlightStandard: {
    //缓存超标验证数据
    module: 'b2b',
    address: 'Flight/GetCheckFlightStandard',
  },
  ApprovalRevoke: {
    //单据审批撤回
    module: 'b2b',
    address: 'CustomerBill/ApprovalRevoke',
  },
  TrainValidateChangeable: {
    //验证火车票改签
    module: 'b2b',
    address: 'TrainTicket/ValidateChangeable',
  },
  SecurityCode: {
    //获取图形验证码
    module: 'b2b',
    address: 'File/SecurityCode',
  },
  SendTravelVerificationCode: {
    //校验图形验证码
    module: 'b2b',
    address: 'Common/SendTravelVerificationCode',
  },
  HouseKeeperRegisterH5: {
    //推广注册
    module: 'b2b',
    address: 'Customer/HouseKeeperRegisterH5',
  },
  ValidateTravelReimbursementBill: {
    //验证费用是否可用
    module: 'b2b',
    address: 'CustomerBill/ValidateTravelReimbursementBill',
  },
  GetEnterpriseBillCommonInfo: {
    //获取单据初始化信息
    module: 'b2b',
    address: 'CustomerBill/GetEnterpriseBillCommonInfo',
  },
  AddReimbursementBill: {
    //新版创建报销单
    module: 'b2b',
    address: 'CustomerBill/AddReimbursementBill',
  },
  GetNewReimbursementBillDetail: {
    //新版获取报销单详情
    module: 'b2b',
    address: 'CustomerBill/GetNewReimbursementBillDetail',
  },
  GetSalerPhones: {
    //获取销售电话
    module: 'b2b',
    address: 'Common/GetSalerPhones',
  },
  GetTravelArea: {
    //获取出差单中出发地目的地
    module: 'b2b',
    address: 'Common/GetTravelArea',
  },
  GetInvoiceTypeList: {
    //获取发票类型Id
    module: 'b2b',
    address: 'CustomerBill/GetInvoiceTypeList',
  },
  CreatePaymentBill: {
    //创建付款单
    module: 'b2b',
    address: 'CustomerBill/CreatePaymentBill',
  },
  GetPaymentBillDetail: {
    //获取付款单详情
    module: 'b2b',
    address: 'CustomerBill/GetPaymentBillDetail',
  },
  GetBillPresonalAccountListPage: {
    //获取往来单位列表
    module: 'b2b',
    address: 'CustomerBill/GetBillPresonalAccountListPage',
  },
  SaveBillPersonalAccountInfo: {
    //保存往来单位详情
    module: 'b2b',
    address: 'CustomerBill/SaveBillPersonalAccountInfo',
  },
  GetBillPersonalAccountDetail: {
    //获取往来单位详情
    module: 'b2b',
    address: 'CustomerBill/GetBillPersonalAccountDetail',
  },
  DeleteBillPersonalAccountInfo: {
    //删除往来单位
    module: 'b2b',
    address: 'CustomerBill/DeleteBillPersonalAccountInfo',
  },
  LoginOut: {
    //退出登录
    module: 'b2b',
    address: 'Customer/LoginOut',
  },
  CreateCorporateReimbursementBill: {
    //创建对公报销单
    module: 'b2b',
    address: 'CustomerBill/CreateCorporateReimbursementBill',
  },
  GetCorporateReimbursementBillDetail: {
    //获取对公报销单详情
    module: 'b2b',
    address: 'CustomerBill/GetCorporateReimbursementBillDetail',
  },
  ResumCorporateReimbursementBill: {
    //获取重新提交报销单详情
    module: 'b2b',
    address: 'CustomerBill/ResumCorporateReimbursementBill',
  },
  GetCostCenter: {
    //获取成本中心
    module: 'b2b',
    address: 'Customer/GetCostCenter',
  },
  GetJsApiConfig: {
    //获取jsconfig配置
    module: 'b2b',
    address: 'oa/GetJsApiConfig',
  },
  SearchDepartmentOrProject: {
    //搜索部门或者项目
    module: 'b2b',
    address: 'Customer/SearchDepartmentOrProject',
  },
  GetAppstoreInternalSkupage: {
    //获取内购地址
    module: 'b2b',
    address: 'OA/GetAppstoreInternalSkupage',
  },
  SaveExtUserInfos: {
    //获取内购地址
    module: 'b2b',
    address: 'Customer/SaveExtUserInfos',
  },
  RevokeOrder: {
    //订单撤销审批
    module: 'b2b',
    address: 'TMC/RevokeOrder',
  },

  GetSupplierList: {
    //供应商列表
    module: 'b2b',
    address: 'CustomerBill/GetSupplierList',
  },

  ApplyBusinessTravelExperienceAccount: {
    module: 'b2b',
    address: 'Customer/ApplyBusinessTravelExperienceAccount',
  },
  ConfirmTravel: {
    //确认出差单
    module: 'b2b',
    address: 'CustomerBill/ConfirmTravel',
  },
  GetReportSummaryBillDetail: {
    module: 'b2b',
    address: 'CustomerBill/GetReportSummaryBillDetail',
  },
  //国际机票 获取航班列表
  GetNationalFlightList: {
    module: 'buiness-middle',
    address: 'Middle/Flight/GetFlightList',
  },
  //国际机票 1.5页获取航班行程信息
  GetNationalSegmentsInfos: {
    module: 'flight-supplier',
    address: 'Business/GetNationalSegmentsInfos',
  },
  //国际机票 1.5页获取指定航班报价详情
  GetNationalFlightSeatList: {
    module: 'flight-supplier',
    address: 'Business/GetNationalFlightSeatList',
  },
  //国际机票 1.5页获取指定航班的机票详情(退改规则，行李规则)
  GetNationalTicketDetails: {
    module: 'flight-supplier',
    address: 'Business/GetNationalTicketDetails',
  },
  GetNationalTicketDetails: {
    module: 'flight-supplier',
    address: 'Business/GetNationalTicketDetails',
  },
  GetLastFlightOrderCustomer: {
    //获取机票填单页上次出差人
    module: 'b2b',
    address: 'Flight/GetLastFlightOrderCustomer',
  },
  GetLastTrainOrderCustomer: {
    //获取火车票填单页上次出差人
    module: 'b2b',
    address: 'TrainTicket/GetLastTrainOrderCustomer',
  },
};

const hotelApi = {
  Resources: {
    GetUpRoomInfo: {
      //获取酒店房型升级
      module: 'hotel',
      address: 'api/hotel/info/GetUpRoomInfo',
    },
    GetHotelDetail: {
      //酒店详情
      module: 'hotel',
      address: 'api/hotel/info/GetHotelDetail',
    },
    GetRoomList: {
      //获取房型列表
      module: 'hotel',
      address: 'api/hotel/info/GetRoomList',
    },
    GetHotelImgList: {
      //酒店图片
      module: 'hotel',
      address: 'api/hotel/info/GetHotelImgList',
    },
    GetHotelFacilities: {
      //酒店设施
      module: 'hotel',
      address: 'api/hotel/info/GetHotelFacilities',
    },
    GetHotelCityInfos: {
      //搜索酒店相关的目的地列表
      module: 'hotel',
      address: 'api/hotel/info/GetHotelCityInfos',
    },
    GetHotelFilter: {
      //获取酒店筛选项
      module: 'hotel',
      address: 'api/hotel/info/GetHotelFilter',
    },
    SearchHotelInfo: {
      //酒店查询
      module: 'hotel',
      address: 'api/hotel/info/SearchHotelInfo',
    },
    SearchPrompts: {
      //获取酒店搜索提示
      module: 'hotel',
      address: 'api/hotel/info/SearchPrompts',
    },
    SetCollectioHotel: {
      //设置收藏酒店
      module: 'hotel',
      address: 'api/hotel/info/SetCollectioHotel',
    },
  },
  Order: {
    GetOrderDetails: {
      //获取订单详情
      module: 'hotel',
      address: 'api/hotel/order/GetOrderDetails',
    },
    Reminder: {
      // 酒店催确认
      module: 'hotel',
      address: 'api/hotel/Order/Reminder',
    },
    GetHotelOrderStatus: {
      // 获取酒店订单状态-催确认轮询用
      module: 'hotel',
      address: 'api/hotel/Order/GetHotelOrderStatus',
    },
    ValidateTravelStandard: {
      //差标验证
      module: 'hotel',
      address: 'api/hotel/order/ValidateTravelStandard',
    },
    CancelHotelOrder: {
      //取消订单
      module: 'hotel',
      address: 'api/hotel/order/CancelHotelOrder',
    },
    GetAvailHotelBooking: {
      //可定检查
      module: 'hotel',
      address: 'api/hotel/order/GetAvailHotelBooking',
    },
    GetBookingPageInfos: {
      //预下单页面
      module: 'hotel',
      address: 'api/hotel/order/GetBookingPageInfos',
    },
    GetHotelOrderPayInfo: {
      //订单支付单页
      module: 'hotel',
      address: 'api/hotel/order/GetHotelOrderPayInfo',
    },
    SubmitHotelOrder: {
      //下单
      module: 'hotel',
      address: 'api/hotel/order/SubmitHotelOrder',
    },
    GetCancelPager: {
      //订单取消原因
      module: 'hotel',
      address: 'api/hotel/order/GetCancelPager',
    },
    GetHotelOrderRefundApplyDetail: {
      //提前离店申请详情
      module: 'hotel',
      address: 'api/hotel/order/GetHotelOrderRefundApplyDetail',
    },
    HotelOrderRefundApply: {
      //提前离店申请
      module: 'hotel',
      address: 'api/hotel/order/HotelOrderRefundApply',
    },
    HotelInvoiceApply: {
      //发票申请
      module: 'hotel',
      address: 'api/Invoice/Apply',
    },
    ActionhronizeOrderStatus: {
      //酒店确认
      module: 'hotel',
      address: 'api/hotel/order/ActionhronizeOrderStatus',
    },
    GetInsuranceDetail: {
      //取消险详情
      module: 'hotel',
      address: 'api/hotel/insurance/GetInsuranceDetail',
    },
    GetProcessDetail: {
      //理赔进度详情
      module: 'hotel',
      address: 'api/hotel/insurance/GetClaimDetail',
    },
    ApplyForCompensation: {
      //提交理赔申请
      module: 'hotel',
      address: 'api/hotel/insurance/CreateClaimInsurance',
    },
    ApplyForSupply: {
      //提交补充材料
      module: 'hotel',
      address: 'api/hotel/insurance/UpdateClaimInsurance',
    },
    GetHotelLastOrderCustomerInfo: {
      //获取上次出差人
      module: 'hotel',
      address: 'api/hotel/order/GetHotelLastOrderCustomerInfo',
    },
  },
};

const carApi = {
  Order: {
    GetBookingInfos: {
      //获取用车填单信息
      module: 'car',
      address: 'api/order/GetBookingInfos',
    },
    GetBookingInfosFast: {
      //获取用车填单信息
      module: 'car',
      address: 'api/order/GetBookingInfosFast',
    },
    ValidateBookableFast: {
      //首页验证
      module: 'car',
      address: 'api/order/ValidateBookableFast',
    },
    SubmitOrder: {
      //用车提交订单
      module: 'car',
      method: 'POST',
      address: 'api/order/SubmitOrder',
    },
    FetchTicekt: {
      //用车获取ticket
      module: 'car',
      address: 'api/didi/FetchTicekt',
    },
    DecryDidiData: {
      //获取用车订单号
      module: 'car',
      address: 'api/didi/DecryDidiData',
    },
    ValidTravelStandard: {
      //验证用户差标验证
      module: 'car',
      address: 'api/didi/ValidTravelStandard',
    },
    QueryDidiRegulations: {
      //获取会员用车制度列表
      module: 'car',
      address: 'api/didi/QueryDidiRegulations',
    },
    SyncApprovalInfo: {
      //获取滴滴出差单详情信息
      module: 'car',
      method: 'POST',
      address: 'api/didi/SyncApprovalInfo',
    },
  },
};

const commonApi = {
  GetCreditCardPageInfos: {
    //行用卡填写页信息
    module: 'common',
    address: 'api/credit/GetCreditCardPageInfos',
  },
  GetBlongBankInfos: {
    //银行列表
    module: 'common',
    address: 'api/credit/GetBlongBankInfos',
  },
  SubmitCreditCard: {
    //保存信用卡
    module: 'common',
    address: 'api/credit/SubmitCreditCard',
  },
  GetExternalOrderInfos: {
    //获取第三方出差单
    module: 'common',
    address: 'api/travelBusinessOrder/GetExternalOrderInfos',
  },
  validateTripFormIsEqualDateAndStart: {
    // 校验出差单和出发地、日期是否一致
    module: 'common',
    address: 'api/travelBusinessOrder/VerifyHomeIntervalExternalOrder',
  },
  GetExternalOrderInfosForIndex: {
    //获取第三方出差单
    module: 'common',
    address: 'api/travelBusinessOrder/GetExternalOrderInfosForIndex',
  },
  DeleteCreditCard: {
    module: 'common',
    address: 'api/credit/DeleteCreditCard',
  },
  GetMyTravelStandard: {
    //查询个人差标
    module: 'common',
    address: 'api/TravelStandardManager/GetMyTravelStandard',
  },
  GetCustomerIndexInfo: {
    //获取用户信息
    module: 'common',
    address: 'api/customer/GetCustomerIndexInfo',
  },
  GetApproveOrderList: {
    // 获取待办数据列表
    module: 'common',
    address: 'api/TravelApprovalManager/GetApproveOrderList',
  },
  GetToDoApproveListSummary: {
    //获取需要审批数量
    module: 'common',
    address: 'api/TravelApprovalManager/GetToDoApproveListSummary',
  },
  GetOrderList: {
    //获取订单列表
    module: 'common',
    address: 'api/Order/GetOrderList',
  },
  GetMyCouponList: {
    //获取我的优惠券
    module: 'common',
    address: 'api/coupon/GetMyCouponList',
  },
  GetApprovalAuditorList: {
    //获取审批人列表
    module: 'common',
    address: 'api/TravelApprovalManager/GetApprovalAuditorList',
  },
  GetMyApprovaler: {
    //查询审批人
    module: 'common',
    address: 'api/TravelApprovalManager/GetMyApprovaler',
  },
  GetPassengerList: {
    //获取常旅列表
    module: 'common',
    address: 'api/Customer/Passenger/GetPassengerList',
  },
  GetPassengerListV3: {
    //获取常旅列表
    module: 'common',
    address: 'api/Customer/Passenger/GetPassengerListV3',
  },
  GetPassengerListV4: {
    //获取常旅列表
    module: 'common',
    address: 'api/Customer/Passenger/GetPassengerListV4',
  },
  GetPassengerListV2: {
    //获取常旅列表
    module: 'common',
    address: 'api/Customer/Passenger/GetPassengerListV2',
  },
  GetPassengerInfo: {
    //获取常旅信息
    module: 'common',
    address: 'api/Customer/Passenger/GetPassengerInfo',
  },
  MaintainPassenger: {
    //新增/编辑常旅
    module: 'common',
    address: 'api/Customer/Passenger/MaintainPassenger',
  },
  MaintainPassengerV2: {
    //新增/编辑常旅
    module: 'common',
    address: 'api/Customer/Passenger/MaintainPassengerV2',
  },
  DeletePassenger: {
    //删除常旅
    module: 'common',
    address: 'api/Customer/Passenger/DeletePassenger',
  },
  GetPassengerInfoV2: {
    module: 'common',
    address: 'api/Customer/Passenger/GetPassengerInfoV2',
  },
  DeleteCustomerIdentity: {
    module: 'common',
    address: 'api/Customer/Passenger/DeleteCustomerIdentity',
  },
  GetPublicMessages: {
    //获取最新通知
    module: 'common',
    address: 'api/PublicMessage/GetPublicMessages',
  },
  GetProjectExtList: {
    //获取自定义项目信息
    module: 'common',
    address: 'api/Customer/GetProjectExtList',
  },
  RegisterSupplierCompany: {
    //华住企业下挂注册
    module: 'common',
    address: 'api/Company/RegisterSupplierCompany',
  },
  RegisterSupplierMember: {
    //绑定供应商账号
    module: 'common',
    address: 'api/Customer/RegisterSupplierMember',
  },
  GetSupplierMemberContrast: {
    //获取供应商关联状态
    module: 'common',
    address: 'api/Customer/GetSupplierMemberContrast',
  },
  GetCouponDetail: {
    //获取供应商关联状态
    module: 'common',
    address: 'api/coupon/GetCouponDetail',
  },
  UnboundSupplierMember: {
    //解绑供应上账号
    module: 'common',
    address: 'api/Customer/UnboundSupplierMember',
  },
  GetPublicConfigure: {
    //获取企业Key
    module: 'common',
    address: 'api/sysconfigs/GetPublicConfigure',
  },
  QueryEpidemicPolicyByCity: {
    //疫情防控信息
    module: 'common',
    address: 'api/publicConfigure/QueryEpidemicPolicyByCity',
  },
  GetEnterpriseConfigs: {
    //获取企业配置
    module: 'common',
    address: 'api/enterprise/config/GetEnterpriseConfigs',
  },
  GetEnterpriseConfigListByConfigType: {
    //根据类型获取企业全局配置
    module: 'common',
    address: 'api/enterprise/config/GetEnterpriseConfigListByConfigType',
  },
  AddProject: {
    //添加项目
    module: 'common',
    address: 'api/Customer/ProjectInfo/AddProject',
  },
  ReceiveManJianCoupons: {
    //领取优惠券
    module: 'common',
    address: 'api/Activity/ReceiveManJianCoupons',
  },
  BindingCustomerMobile: {
    //绑定手机号
    module: 'common',
    address: 'api/Customer/BindingCustomerMobile',
  },
  CheckCustomerPhone: {
    //验证手机号是否完善
    module: 'common',
    address: 'api/Customer/CheckCustomerPhone',
  },
  GetFinanceTripReason: {
    //获取财务系统消费事由
    module: 'common',
    address: 'api/Finance/GetFinanceTripReason',
  },
  FinanceCostBelongInfo: {
    //根据项目中心查询费用归属信息
    module: 'common',
    address: 'api/Finance/FinanceCostBelongInfo',
  },
  UpdateEnterpriseContactInfo: {
    //设置企业联系人
    module: 'common',
    address: '/api/enterprise/UpdateEnterpriseContactInfo',
  },
  AddDingEnterpriseRefereeInfo: {
    //设置个人信息
    module: 'common',
    address: '/api/Enterprise/AddDingEnterpriseRefereeInfo',
  },
  GetOrderParams: {
    //根据订单号获取参数
    module: 'common',
    address: '/api/order/GetOrderParams',
  },
  GetEnterpriseBonusPointsOpenStatus: {
    //获取企业积分版本
    module: 'common',
    address: '/api/enterprise/config/GetEnterpriseBonusPointsOpenStatus',
  },
  GetEnterpriseBonusPointsInfoDesc: {
    // 获取企业积分规则
    module: 'common',
    address: '/api/enterprise/config/GetEnterpriseBonusPointsInfoDesc',
  },
  GetPartnerLoginUrl: {
    // 第三方嵌入登录
    module: 'common',
    address: '/api/partner/GetPartnerLoginUrl',
  },
  GetCustomerInfoByToken: {
    //验证第三方跳转用户信息
    module: 'common',
    address: '/api/partner/GetCustomerInfoByToken',
  },
  VerifyReservationPermissions: {
    //获取预订权限
    module: 'common',
    address: '/api/Customer/Passenger/VerifyReservationPermissions',
  },
  GetUserBindInfo: {
    //获取用户绑定信息
    module: 'common',
    address: '/api/Customer/GetUserBindInfo',
  },
  GetSupplierMemberContrastInfo: {
    //获取酒店联合登录绑定情况
    module: 'common',
    method: 'POST',
    address: 'api/Customer/GetSupplierMemberContrastInfo',
  },
  BindFeiZhu: {
    //绑定飞猪会员
    module: 'common',
    address: '/api/Customer/BindFeiZhu',
  },
  UpdateFeiZhuBind: {
    //更新飞猪绑定状态
    module: 'common',
    address: '/api/Customer/UpdateFeiZhuBind',
  },
  UnBindFeiZhu: {
    //解绑飞猪会员绑定
    module: 'common',
    address: '/api/Customer/UnBindFeiZhu',
  },
};

const trainApi = {
  Train12306TravelerLogin: {
    //12306登录接口
    module: 'b2b',
    address: 'Customer/Train12306TravelerLogin',
  },
  Validate12306TravelerLogin: {
    //验证12306登录
    module: 'b2b',
    address: 'Customer/Validate12306TravelerLogin',
  },
  Get12306PassengerList: {
    //获取12306常旅客
    module: 'b2b',
    address: 'Customer/Get12306PassengerList',
  },
  Maintain12306Passenger: {
    //新增12306常旅客
    module: 'b2b',
    address: 'Customer/Maintain12306Passenger',
  },
  Delete12306Passenger: {
    //删除12306常旅客
    module: 'b2b',
    address: 'Customer/Delete12306Passenger',
  },
  Get12306PassengerInfo: {
    //获取12306常旅信息
    module: 'b2b',
    address: 'Customer/Get12306PassengerInfo',
  },
  GetTravelerVerifyResult: {
    //火车票核验
    module: 'b2b',
    address: 'Customer/GetTravelerVerifyResult',
  },
  Get12306AccountList: {
    //获取用户关联的12306账号列表
    module: 'b2b',
    address: 'Customer/Get12306AccountList',
  },
  Delete12306Account: {
    //删除用户关联的12306账号信息
    module: 'b2b',
    address: 'Customer/Delete12306Account',
  },
};

const expressApi = {
  Login: {
    //快递一键登录
    module: 'express',
    address: 'SZHT/Login',
  },
};

const takeoutApi = {
  GetBookingInfos: {
    //初始化美团外卖首页
    module: 'waimai',
    address: 'index/getBookingInfo',
  },
  CreateOrder: {
    //创建订单
    module: 'waimai',
    address: 'order/presave',
  },
  getOverReasons: {
    //获取超标原因
    module: 'waimai',
    address: 'validate/getOverReasons',
  },
  validateStandard: {
    //验证是否超标
    module: 'waimai',
    address: 'validate/validateStandard',
  },
  addOverReason: {
    //保存超标原因
    module: 'waimai',
    address: 'order/addOverReason',
  },
  getDetailUrl: {
    //获取订单详情链接
    module: 'waimai',
    address: 'order/getDetailUrl',
  },
};

const costApi = {
  //迈为费控接口
  SaveExpenseCostInfo: {
    //保存费用
    module: 'expensecontrol',
    address: 'Expense/SaveExpenseCostInfo',
  },
  GetExpenseCostList: {
    //获取费用列表
    module: 'expensecontrol',
    address: 'Expense/GetExpenseCostList',
  },
  UpdateExpenseCostStatus: {
    //修改费用状态
    module: 'expensecontrol',
    address: 'Expense/UpdateExpenseCostStatus',
  },
  GetCostTypeList: {
    //获取费用类型列表
    module: 'expensecontrol',
    address: 'Expense/GetCostTypeList',
  },
  GetExpenseCostDetail: {
    //获取费用明细
    module: 'expensecontrol',
    address: 'Expense/GetExpenseCostDetail',
  },
  CreateLoanExpense: {
    //创建借款申请单
    module: 'expensecontrol',
    address: 'Expense/CreateLoanExpense',
  },
  GetLoanExpenseDetail: {
    //获取借款单详情
    module: 'expensecontrol',
    address: 'Expense/GetLoanExpenseDetail',
  },
  GetExpenseList: {
    //获取单据列表
    module: 'expensecontrol',
    address: 'Expense/GetExpenseList',
  },
  CreateRepaymentExpense: {
    //创建还款单
    module: 'expensecontrol',
    address: 'Expense/CreateRepaymentExpense',
  },
  GetRepaymentExpenseDetail: {
    //获取还款但详情
    module: 'expensecontrol',
    address: 'Expense/GetRepaymentExpenseDetail',
  },
  GetIsShowProjectAttribution: {
    //获取是否显示项目归属
    module: 'expensecontrol',
    address: 'Expense/GetIsShowProjectAttribution',
  },
  GetProjectAttributionList: {
    //项目归属查询
    module: 'expensecontrol',
    address: 'Expense/GetProjectAttributionList',
  },
  GetExpenseCommonInfo: {
    //公共基础信息
    module: 'expensecontrol',
    address: 'Expense/GetExpenseCommonInfo',
  },
  GetReceiptAccountList: {
    //获取收款信息列表
    module: 'expensecontrol',
    address: 'Expense/GetReceiptAccountList',
  },
  SaveReceiptAccountInfo: {
    //新增编辑收款账户信息
    module: 'expensecontrol',
    address: 'Expense/SaveReceiptAccountInfo',
  },
  DeleteReceiptAccountInfo: {
    //删除收款账户信息
    module: 'expensecontrol',
    address: 'Expense/DeleteReceiptAccountInfo',
  },
  GetReceiptAccountInfo: {
    //根据Id,Type 获取收款单位信息
    module: 'expensecontrol',
    address: 'Expense/GetReceiptAccountInfo',
  },
  GetPayerAccountList: {
    //付款单位列表
    module: 'expensecontrol',
    address: 'Expense/GetPayerAccountList',
  },
  ApprovalRevoke: {
    //单据撤销
    module: 'expensecontrol',
    address: 'Expense/ApprovalRevoke',
  },
  SaveExpenseInfo: {
    //创建报销单
    module: 'expensecontrol',
    address: 'Expense/SaveExpenseInfo',
  },
  SearchExpenseDetail: {
    //获取报销单详情
    module: 'expensecontrol',
    address: 'Expense/SearchExpenseDetail',
  },
  GetMyAccountBook: {
    //获取账本统计信息
    module: 'expensecontrol',
    address: 'Statistics/GetMyAccountBook',
  },
  AddCostInvoice: {
    //识别发票并添加
    module: 'expensecontrol',
    address: 'CostInvoice/AddCostInvoices',
  },
  DeleteCostInvoice: {
    //删除发票
    module: 'expensecontrol',
    address: 'CostInvoice/DeleteCostInvoice',
  },
  GetInvoiceTypeList: {
    //获取发票类型
    module: 'expensecontrol',
    address: 'CostInvoice/GetInvoiceTypeList',
  },
  ValidateTravelReimbursementExpense: {
    //验证费用
    module: 'expensecontrol',
    address: 'Expense/ValidateTravelReimbursementExpense',
  },
  GetTravelApplyExpenseDetail: {
    //获取出差单详情
    module: 'expensecontrol',
    address: 'Expense/GetTravelApplyExpenseDetail',
  },
  ApprovalExpense: {
    //审批单据
    module: 'expensecontrol',
    address: 'Expense/ApprovalExpense',
  },
};

const financeApi = {
  listBankType: {
    // 查询银行类型列表
    module: 'finance-asset',
    address: 'asset/listBankType',
  },
  pageBankInfo: {
    // 查询银行信息分页
    module: 'finance-asset',
    address: 'asset/pageBankInfo',
  },
};
// 私车公用模块API
const scgyApi = {
  haveMileage: {
    // 判断用户当前是否存在未结束的里程
    method: 'get',
    module: 'scgy',
    address: 'mileage/haveMileage',
  },
  delMilDetail: {
    // 删除里程详情
    method: 'get',
    module: 'scgy',
    address: 'mileage/delMilDetail',
  },
  updateMileage: {
    // 编辑里程信息
    method: 'post',
    module: 'scgy',
    address: 'mileage/updateMileage',
  },
  selMileageById: {
    // 根据ID获取里程详情
    method: 'get',
    module: 'scgy',
    address: 'mileage/selMileageById',
  },
  insertMileageDetail: {
    // 新增里程单详细记录
    method: 'get',
    module: 'scgy',
    address: 'mileage/insertMileageDetail',
  },
  startMileage: {
    // 开始行程
    method: 'post',
    module: 'scgy',
    address: 'mileage/startMileage',
  },
  computeMileage: {
    // 计算补贴费用
    method: 'get',
    module: 'scgy',
    address: 'mileage/computeMileage',
  },
  resetMileage: {
    // 重置
    method: 'get',
    module: 'scgy',
    address: 'mileage/resetMileage',
  },
  save: {
    // 保存
    method: 'get',
    module: 'scgy',
    address: 'mileage/save',
  },
  mileageList: {
    // 获取里程费用列表
    method: 'get',
    module: 'scgy',
    address: 'mileage/mileageList',
  },
  updateTollFees: {
    // 修改过路费
    method: 'get',
    module: 'scgy',
    address: 'mileage/updateTollFees',
  },
  saveMileageOrder: {
    // 修改过路费
    method: 'post',
    module: 'scgy',
    address: 'mileage-order/saveMileageOrder',
  },
  needTravelBusiness: {
    // 修改过路费
    method: 'post',
    module: 'scgy',
    address: 'mileage/needTravelBusiness',
  },
};

module.exports = {
  apiName,
  hotelApi,
  commonApi,
  carApi,
  trainApi,
  expressApi,
  takeoutApi,
  costApi,
  financeApi,
  scgyApi,
};
